// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Sg","content":"Tg","crumbsList":"Ug","dropdownsWrap":"Vg"};